/** @internal */
export const OP_BOTH_RUNNING = "BothRunning";
/** @internal */
export const OP_LEFT_DONE = "LeftDone";
/** @internal */
export const OP_RIGHT_DONE = "RightDone";
//# sourceMappingURL=channelMergeState.js.map